import dayjs from "dayjs";
import { getDueDatePart, getDueTimePart } from "./dueDateTime";
import { normalizeRepeatRule } from "./recurrence";

/**
 * Build volunteer opportunity form defaults from an event record (create-from-event flow).
 * @param {object} event
 * @returns {object} Values compatible with VolunteerOpportunities getDetailFormValues / applyDetailFormValues
 */
export function getVolunteerOpportunityDraftFromEvent(event) {
  const eventName = (event?.name != null ? String(event.name) : "").trim();
  const eventDate = getDueDatePart(event?.start_datetime) || dayjs().format("YYYY-MM-DD");
  return {
    name: eventName ? `Volunteering - ${eventName}` : "Volunteering - Event",
    description: event?.description != null ? String(event.description) : "",
    eventDate,
    startTime: getDueTimePart(event?.start_datetime) || "09:00",
    endTime: getDueTimePart(event?.end_datetime) || "10:00",
    repeat_rule: normalizeRepeatRule(event?.repeat_rule ?? event?.repeat, eventDate),
    location: event?.location != null ? String(event.location) : "",
    category: "",
    status: "Open",
    event_id: event?._id != null ? String(event._id) : "",
  };
}

/**
 * Slim event snapshot for router state (create-from-event navigation).
 */
/** Keep only opportunities linked to the given event (client-side safety net). */
export function filterVolunteerOpportunitiesByEventId(opportunities, eventId) {
  const eid = eventId != null ? String(eventId).trim() : "";
  if (!eid) return [];
  return (Array.isArray(opportunities) ? opportunities : []).filter(
    (o) => String(o?.event_id ?? "").trim() === eid
  );
}

export function toCreateFromEventState(event) {
  if (!event) return null;
  return {
    _id: event._id,
    name: event.name,
    description: event.description,
    start_datetime: event.start_datetime,
    end_datetime: event.end_datetime,
    location: event.location,
    repeat_rule: event.repeat_rule ?? event.repeat ?? null,
  };
}
